/** @jsx isolateComponent */
import React from 'react';

import { labelStyles, responsiveStyles } from '@zapier/common-utils';
import { SizeType } from '@zapier/product-get-help/src/types';
import { isolateComponent } from '@zapier/style-encapsulation';

const CSS_CONTAINER_MAX_WIDTH = `${20 + 746 + 20}px`;
const CSS_CONTAINER_DEFAULT_PADDING_TOP = 0;
const CSS_CONTAINER_DEFAULT_PADDING_LEFT = 20;
const CSS_CONTAINER_DEFAULT_PADDING_BOTTOM = 0;
const CSS_CONTAINER_DEFAULT_PADDING_RIGHT = 20;

type ContainerProps = {
  /** Size to display. */
  size?: SizeType;
  /** Children to render */
  children: React.ReactNode;
  //** Padding Top in pixels */
  paddingTop?: number;
  //** Padding Bottom in pixels */
  paddingBottom?: number;
  //** Padding Left in pixels */
  paddingLeft?: number;
  //** Padding Right in pixels */
  paddingRight?: number;
};

const Styles = labelStyles(__filename, {
  container: (
    size: SizeType,
    paddingTop: number,
    paddingBottom: number,
    paddingLeft: number,
    paddingRight: number
  ) =>
    responsiveStyles(size, {
      small: {
        margin: '70px auto',
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
      },
      large: {
        margin: '0px auto',
        maxWidth: CSS_CONTAINER_MAX_WIDTH,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
      },
    }),
});

/**
 * A Container to make sure the content doesn't get too wide.
 */
const Container = ({
  children,
  size = 'large',
  paddingTop = CSS_CONTAINER_DEFAULT_PADDING_TOP,
  paddingBottom = CSS_CONTAINER_DEFAULT_PADDING_BOTTOM,
  paddingLeft = CSS_CONTAINER_DEFAULT_PADDING_LEFT,
  paddingRight = CSS_CONTAINER_DEFAULT_PADDING_RIGHT,
}: ContainerProps) => {
  return (
    <div
      css={Styles.container(
        size,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight
      )}
    >
      {children}
    </div>
  );
};

export default Container;
